import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import schema from './schema';
import SubmitButton from './../SubmitButton/index';

const Form = ({onSubmit}) => {
  const [email, setEmail] = useState('');
  const [eventName, setEventName] = useState('');
  const [errors, setErrors] = useState({});

  const handleSubmit = async () => {
    schema.validate({email, eventName}, { abortEarly: false })
      .then((data) => {
        onSubmit(data);
        setEmail('');
        setEventName('');
      })
      .catch((err) => {
        const errors = err.inner.reduce((acc, cur) => ({...acc, [cur.path]: cur.errors[0]}), {})
        setErrors(errors)
      })
  }

  return (
    <div
      className='form'
    >
      <TextField
        margin="normal"
        id="name"
        label="Email"
        type="email"
        fullWidth
        variant="outlined"
        onChange={(e) => {setEmail(e.target.value); setErrors({...errors, email: null})}}
        value={email}
        error={!!errors.email}
        helperText={errors.email}
      />

      <TextField
        label="Appointment Name (e.g. Pickup - Table & Chairs, Inspection - File Cabinet, etc.)"
        margin="normal"
        variant="outlined"
        id='name'
        fullWidth
        value={eventName}
        onChange={(e) => {setEventName(e.target.value); setErrors({...errors, eventName: null})}}
        error={!!errors.eventName}
        helperText={errors.eventName}
      />

      <SubmitButton
        title='Create Appointment'
        onClick={handleSubmit}
      >
        Send
      </SubmitButton>
    </div>
  );
}

export default Form;